const atualizarPedidos = (state, pedidos) => {
    state.pedidos = pedidos;
}

const atualizarPedido = (state, pedido) => {
    state.pedido = pedido;
}

const updatePedido = (state, pedido) => {
    if (!pedido || pedido.id == null) return;

    const index = state.pedidos.findIndex(item => item.id === pedido.id);
    if (index >= 0) {
        state.pedidos.splice(index, 1, JSON.parse(JSON.stringify(pedido)));
    }
}

const upsertPedido = (state, pedido) => {
    if (!pedido || pedido.id == null) return;

    const pedidoLista = JSON.parse(JSON.stringify(pedido));
    const index = state.pedidos.findIndex(item => item.id === pedido.id);
    if (index >= 0) {
        state.pedidos.splice(index, 1, pedidoLista);
    } else {
        state.pedidos.push(pedidoLista);
    }
    state.ultimaAtualizacaoListaPedido = new Date();
}

const atualizarPedidosEntrada = (state, pedidosEntrada) => {
    state.pedidosEntrada = pedidosEntrada;
}

export default {
    atualizarPedidos,
    atualizarPedido,
    atualizarPedidosEntrada,
    updatePedido,
    upsertPedido
}
